import { Box, Stack } from "@mui/material";
import { useBreadcrumb } from "hooks/useBreadcrumbs";

import { CoverageStatCards } from "./CoverageStatCards";
import { TrueUpSection } from "./TrueUpSection";
import { UnmatchedExpansionSection } from "./UnmatchedExpansionSection";

export const Coverage = () => {
  useBreadcrumb({ label: "Coverage", to: "/staff/cers/coverage" });
  return (
    <Box sx={{ pt: 3 }}>
      <Stack spacing={3}>
        <CoverageStatCards />
        <TrueUpSection />
        <UnmatchedExpansionSection />
      </Stack>
    </Box>
  );
};
